import React, {Suspense, useEffect, useState} from "react";

const Picker = React.lazy(() => import('@emoji-mart/react'));

export const EmojiPicker = ({onEmojiSelect}) => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Picker
                // emojiData={emojiData}
                theme={"dark"}
                onEmojiSelect={onEmojiSelect} />
        </Suspense>
    );
};
